import axios from 'axios';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import AdminLayout from '../Componets/AdminLayout';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';

export default function Sheet() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { subjectName, examId, subjectId } = location.state || {};
  const [records, setRecords] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [facultys, setFacultys] = useState([]);
  const [modalImages, setModalImages] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [files, setFiles] = useState([]);
  const [folderName, setFolderName] = useState('');
  const [selectedBarcode, setSelectedBarcode] = useState(''); // Store selected barcode
  const [marks, setMarks] = useState('');
  const [loading2, setLoading2] = useState(false);
  const [count, setCount] = useState(0);

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    fetchRecords(currentPage, perPage);
    fetchFaculties();
  }, [currentPage, perPage]);

  const fetchRecords = async (page, perPage) => {
    setLoading(true);
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(
        `${apiUrl}/api/rejectedansersheet/list?examId=${examId}&subjectId=${subjectId}&skip=${(page - 1) * perPage}&take=${perPage}`,
        {
          headers: { Authorization: token },
        }
      );
      setRecords(response.data.results);
      setTotalRows(response.data.count);
    } catch (error) {
      console.error('Error fetching records:', error);
      error.response?.status === 401 && navigate('/');
    } finally {
      setLoading(false);
    }
  };

  const fetchFaculties = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`${apiUrl}/api/faculty`, {
        headers: { Authorization: token },
      });
      setFacultys(response.data.facultys);
    } catch (error) {
      console.error('Error fetching faculties:', error);
      toast.error('Failed to fetch faculties.');
      error.response?.status === 401 && navigate('/');
    }
  };

  const getFacultyNameById = (facultyId) => {
    const faculty = facultys.find((faculty) => faculty.id === facultyId);
    return faculty ? faculty.name : 'Unknown';
  };

  const columns = [
    {
      name: 'No',
      selector: (row, index) => index + 1,
      width: '50px',
      center: 'true',
    },
    {
      name: 'Reason',
      selector: (row) => row.reasontext,
      sortable: true,
      width: '150px',
    },
    {
      name: 'Description',
      selector: (row) => row.text,
      sortable: true,
    },
    {
      name: 'Rejected By',
      selector: (row) => getFacultyNameById(row.facultyId),
      sortable: true,
      width: '150px',
    },
    {
      name: 'Sheet Barcode',
      selector: (row) => row.barcode,
      sortable: true,
      width: '150px',
    },
    {
      name: 'Block No',
      selector: (row) => row.blockNumber,
      sortable: true,
      width: '98px',
    },
    {
      name: 'Actions',
      width: '115px',
      center: 'true',
      cell: (row) => (
        <div>
          <button
            className="btn btn-primary btn-sm"
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
            onClick={() => handleModalOpen(row)}
            data-tooltip-id="my-tooltip"
            data-tooltip-content="View Images"
          >
            <i className="bi bi-clipboard"></i>
          </button>
          <button
            className={`btn btn-sm ms-2 ${!row.isRejectedAnsweeSheet ? 'btn-success' : 'btn-primary'}`}
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
            onClick={() => setSelectedBarcode(row.barcode)} // Set the barcode when opening the modal
            data-tooltip-id="my-tooltip"
            data-tooltip-content={
              !row.isRejectedAnsweeSheet ? 'Upload Answer Sheet' : 'Add Marks'
            }
          >
            <i className="bi bi-gear"></i>
          </button>
        </div>
      ),
    },
  ];
  // this is line style not get cooment out
  const conditionalRowStyles = [
    {
      when: (row) => !row.isRejectedAnsweeSheet,
      style: {
        color: '#12971f',
      },
    },
  ];

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerPageChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };

  const handleModalOpen = async (row) => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(
        `${apiUrl}/api/rejectedansersheet/image/${row.examId}/${row.subjectId}/${row.barcode}`,
        {
          headers: { Authorization: token },
        }
      );
      setModalImages(response.data.images);
    } catch (error) {
      error.response?.status === 401 && navigate('/');
      console.error('Error fetching image data:', error);
      toast.error('Failed to fetch image data.');
    }
  };

  const handleFileChange = (event) => {
    const selectedFiles = event.target.files;
    if (selectedFiles.length === 0 && folderName !== 'answersheets') {
      toast.error('Please select a folder with files.');
      return;
    }
    setFiles(selectedFiles);
    const files = event.target.files;

    if (files.length > 0) {
      const fullPath = files[0].webkitRelativePath;
      const folder = fullPath.split('/')[0];
      setFolderName(folder);
    }
  };

  const handleSubmit = async (event) => {
    setLoaded(true);
    event.preventDefault();

    const formData = new FormData();
    for (const file of files) {
      formData.append('files', file);
      formData.append('relativePaths[]', file.webkitRelativePath);
    }
    formData.append('examId', examId); // Ensure examId is correctly used
    formData.append('subjectId', subjectId);
    formData.append('barcode', selectedBarcode); // Use selectedBarcode here

    const token = localStorage.getItem('token');

    try {
      const response = await axios.post(
        `${apiUrl}/api/rejectedansersheet/upload-student-rejectAnswersheet`,
        formData,
        {
          headers: {
            Authorization: ` ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      setLoaded(false);
      toast.success('Files uploaded successfully');
      fetchRecords(currentPage, perPage); // Update the records after upload
      fetchFaculties();
      closemodel();
    } catch (error) {
      error.response?.status === 401 && navigate('/');
      console.error('Error uploading files:', error);
      setLoaded(false);
      toast.error(error.response.data.message);
    }
  };

  const closemodel = () => {
    const closeButton = document.querySelector('#exampleModal .btn-close');
    if (closeButton) {
      closeButton.click();
      setFolderName('');
      setFiles([]);
      setSelectedBarcode('');
    }
  };
  const handleSubmitmarks = async (e) => {
    e.preventDefault();
    setLoading2(true);
    const token = localStorage.getItem('token');
    const data = JSON.stringify({
      examId: examId, // Hardcoded, change as per your need
      subjectId: subjectId, // Hardcoded, change as per your need
      barcode: selectedBarcode, // Hardcoded, change as per your need
      marks: parseInt(marks), // The marks entered in the form
    });

    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${apiUrl}/api/rejectedansersheet/answersheet/mark/add?allocationType=NORMAL`,
      headers: {
        Authorization: `${token}`, // Replace with actual token
        'Content-Type': 'application/json',
      },
      data: data,
    };

    try {
      const response = await axios.request(config);

      toast.success('Marks added successfully');
      closemodel();
      setMarks('');
      fetchRecords(currentPage, perPage);
      fetchFaculties();
    } catch (error) {
      error.response?.status === 401 && navigate('/');
      console.error('Error adding marks:', error);
      toast.error(error.response.data.message);
    } finally {
      setLoading2(false);
    }
  };

  return (
    <div>
      <main id="main" className="main">
        <AdminLayout ac10="active">
          <div className="pagetitle">
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admin/dashboard">Dashboard</Link>
                </li>

                <li
                  className="breadcrumb-item cursor-pointer"
                  onClick={() => navigate(-2)}
                >
                  Exams
                </li>
                <li
                  className="breadcrumb-item cursor-pointer"
                  onClick={() => navigate(-1)}
                >
                  Subject List
                </li>
                <li className="breadcrumb-item active">
                  Rejected Sheet of {subjectName}
                </li>
              </ol>
            </nav>
          </div>
          <hr className="mb-0" />
          <div className="row">
            <div className="container">
              <div className="datatable-top">
                <div className="datatable-search">
                  <input
                    className="form-control"
                    type="search"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={records}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerPageChange}
                  onChangePage={handlePageChange}
                  className="custom-table"
                  conditionalRowStyles={conditionalRowStyles}
                />
                <ToastContainer
                  position="top-center"
                  style={{ width: 'auto' }}
                />
              </div>
            </div>
          </div>
        </AdminLayout>
        <Tooltip id="my-tooltip" />
      </main>

      {/* Modal for displaying images */}
      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-l modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">
                Images for {selectedBarcode}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {modalImages.length > 0 ? (
                modalImages.map((image, index) => (
                  <img
                    key={image.index}
                    src={`${image.base64Image}`}
                    alt={image.imageName}
                    className="img-fluid mb-2"
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                      border: '1px solid black',
                    }}
                  />
                ))
              ) : (
                <p>No images found.</p>
              )}
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for uploading files */}
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title" id="exampleModalLabel">
                Upload Answer Sheet & Add Marks ({selectedBarcode})
              </h6>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              <div className="container text-center">
                <div className="row">
                  {/* Form for manually adding marks */}
                  <div className="col-12">
                    <form onSubmit={handleSubmitmarks}>
                      <div className="mb-3">
                        <div className="form-floating">
                          <input
                            className="form-control"
                            type="number"
                            name="name"
                            id="marks"
                            value={marks}
                            onChange={(e) => setMarks(e.target.value)}
                            placeholder="Enter marks"
                            required
                          />
                          <label htmlFor="marks">
                            Marks <span className="text-danger">*</span>
                          </label>
                        </div>
                      </div>
                      <div className="mb-3">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={loading2}
                        >
                          {loading2 ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Submitting...
                            </>
                          ) : (
                            <>Submit Marks</>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>

                  {/* Divider */}
                  <hr className="my-4" />

                  {/* Form for uploading answer sheet */}
                  <div className="col-12">
                    <form
                      id="uploadForm"
                      onSubmit={handleSubmit}
                      encType="multipart/form-data"
                    >
                      <div
                        className="upload-area"
                        onClick={() =>
                          document.getElementById('folderInput').click()
                        }
                      >
                        <div className="icon">
                          <img
                            src="https://cdn-icons-png.freepik.com/512/16001/16001736.png"
                            alt="Upload Icon"
                            style={{ maxWidth: '100px' }}
                          />
                        </div>
                        <p className="text">Click to upload Answer Sheet</p>
                        <input
                          type="file"
                          id="folderInput"
                          webkitdirectory="true"
                          multiple
                          onChange={handleFileChange}
                          style={{ display: 'none' }}
                        />
                        {folderName && (
                          <p className="folder-name">{folderName}</p>
                        )}
                      </div>
                      <div className="mt-3">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={loaded}
                        >
                          {loaded ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Uploading...
                            </>
                          ) : (
                            <>Upload Sheet</>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => closemodel()}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
